<template>
	<div class="p-grid p-pb-1">
		<div class="p-col-12 p-pt-1 p-pb-1">

      <div class="p-grid p-nogutter">
        <div class="p-col">
          <h2>
            <a @click="$router.push({ name: 'appliance-details', params: { serialNumber: serialNumber } })" style="cursor: pointer">{{appliance.name ?? $functions.fixModelName(appliance.modelNumber)}}</a>
            <img class="p-pl-3 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/>
            {{$t('library.title_device')}}
          </h2>
        </div>
        <div class="p-col-fixed p-pb-4" style="width: fit-content">
          <Button v-if="buttonVisible" :label="$t('library.cycle.new_cycle_button')" @click="createCycle" icon="irinox-icon-button pi pi-plus" iconPos="left" />
        </div>
      </div>

      <Library :serialNumber="serialNumber" :appliance="appliance" />

      <FunctionSelect :visible="dialog.functionSelect" 
        @update:visible="dialog.functionSelect = $event"
        @select:function="functionSelected" 
        :serialNumber="serialNumber" :appliance="appliance" />
      
		</div>

    <!-- <div class="library-energy-disclaimer"><span>{{ $t('library.energy_disclaimer') }}</span></div> -->

	</div>
</template>

<script>
import Library from './Library.vue';
import FunctionSelect from './FunctionSelect.vue';
import { mapGetters } from 'vuex';

export default {
  
  components: {
      Library,
      FunctionSelect,
    },
    data() {
        return {
          serialNumber: this.$route.params.serialNumber,
          dialog: {
            functionSelect: false
          }
        };
    },
    computed: {
      ...mapGetters({
          role: 'userdata/role',
        }),
      appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
        buttonVisible: function() {
          return this.role === "USER";
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
      createCycle() {
        this.dialog.functionSelect = true;
      },
      functionSelected(functionId) {
        this.dialog.functionSelect = false;
        this.$router.push({ name: 'appliance-recipe-create', params: { serialNumber: this.serialNumber, function: functionId } })
      }
    }

}
</script>

<style scoped>
</style>